import Services from "../../../services";

class COAApi {
  get() {
    return Services.get("/ang/coa");
  }
}

export default new COAApi();
